import React, { useState, useEffect } from 'react';
import { jsonResponseHandler } from '../utils/FetchHelper'
import MobileForm from '../components/design/MobileForm'
import LoadingBox from "../components/common/LoadingBox";
import { useDispatch } from "react-redux";
import LoadErrorBox from "../components/common/LoadErrorBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import {addPrefix} from "../utils/UriUtil";

export default function MobileSkinSettingApp() {

  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)
  const [data, setData] = useState(null)

  function init() {
    setInitialized(InitStatus.INIT_DOING)
    fetch(addPrefix("/manage/design/mobile.json"), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(res => res.json())
      .then(data => {
        setData(data)
        setInitialized(InitStatus.INIT_SUCCESS)
      })
      .catch(e => {
        console.error(e);
        setInitialized(InitStatus.INIT_FAIL)
      })
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <div className="inner_article decoration_article">
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
      { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={init}/>}
      { (initialized === InitStatus.INIT_SUCCESS ) &&
      <div className="blog_mobile" id="mobileSkinSetting-app">
        <h3 className="tit_cont">모바일 꾸미기 설정</h3>
        <MobileForm data={data} />
      </div>
      }
    </div>
  )
}
